var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FDD63C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 32V36M34.9998 40H35.0098M33.6151 26.8917L25.3902 41.0983C24.934 41.8863 24.7059 42.2803 24.7396 42.6037C24.769 42.8857 24.9168 43.142 25.1461 43.3088C25.4091 43.5 25.8643 43.5 26.7749 43.5H43.2246C44.1352 43.5 44.5904 43.5 44.8534 43.3088C45.0827 43.142 45.2305 42.8857 45.2599 42.6037C45.2936 42.2803 45.0655 41.8863 44.6093 41.0983L36.3844 26.8917C35.9299 26.1065 35.7026 25.714 35.4061 25.5821C35.1474 25.4671 34.8521 25.4671 34.5935 25.5821C34.2969 25.714 34.0696 26.1065 33.6151 26.8917Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.8cb0a66fb962388878d4cdc156ce9bfa.svg";
export { ForwardRef as ReactComponent };